import {
  ChangeDetectionStrategy,
  Component,
  HostListener,
  afterNextRender,
  computed,
  inject,
  resource,
  signal,
} from "@angular/core";

import { IotnetGateway } from "../../apis/stats/rest/models";
import { NavigationComponent } from "../../components/common/navigation/navigation";
import { IotnetGatewayDetail } from "../../components/iotnet/iotnet-gateway-detail/iotnet-gateway-detail";
import { IotnetMap } from "../../components/iotnet/iotnet-map/iotnet-map";
import { reportAndReturn } from "../../helpers/report-to-sentry";
import { AuthService } from "../../services/authservice";
import { IOTNET_REPOSITORY } from "./iotnet-repository.port";

@Component({
  selector: "page-iotnet",
  templateUrl: "iotnet.html",
  styleUrls: ["./iotnet.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [IotnetGatewayDetail, IotnetMap, NavigationComponent],
})
export class IotNetPage {
  private readonly auth = inject(AuthService);
  private readonly iotnet = inject(IOTNET_REPOSITORY);

  protected readonly selectedGateway = signal<IotnetGateway | null>(null);
  protected readonly customerId = computed(() => this.auth.viewingCustomer().customerId);
  protected readonly topOffset = signal(0); // keep nav bar visible above map

  protected readonly gateways = resource({
    params: () =>
      this.auth.viewingCustomer().customerId ? { customer_id: this.auth.viewingCustomer().customerId } : undefined,
    loader: ({ params }) => this.iotnet.getIotnetGatewaysForCustomer(params).catch(reportAndReturn([])),
    defaultValue: [],
  });

  constructor() {
    afterNextRender(() => this.updateTopOffset());
  }

  @HostListener("window:resize")
  protected updateTopOffset(): void {
    const headerBottom = document.querySelector("header.header")?.getBoundingClientRect().bottom ?? 0;
    this.topOffset.set(Math.max(0, headerBottom));
  }
}
